module.exports = __webpack_public_path__ + "media/images/badge/supercoppa-finalista-9df39ac4cd1afb2b1cf34080ba9d3087.png";